import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import Config from '../server.json'; 

const ShowResolutions = () => {
  const { resno } = useParams();
  const [meta, setMeta] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(`${Config.RESOLUTION_DETAIL_API_URL}?resno=${encodeURIComponent(resno)}`)
      .then(res => res.json())
      .then(data => {
         setMeta(data);
        setLoading(false);
      })
      .catch(err => {
        console.error(err);
        setLoading(false);
      });
  }, [resno]);

  const pdfUrl = `${Config.RESOLUTIONPDF_DETAIL_API_URL}?resno=${encodeURIComponent(resno)}`;


  if (loading) {
    return <p className="p-4 text-center">Loading…</p>;
  }

  if (!meta || meta.status === 'error') {
    return (
      <div className="p-4">
        <Link to="/resolutions" className="text-blue-600 hover:underline">
          ← Back to list
        </Link>
        <p className="mt-4 text-red-500">Failed to load resolution details.</p>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-100 py-8 px-4 sm:px-6 lg:px-8">
      <div className="max-w-3xl mx-auto bg-white p-6 rounded-lg shadow">
     
        <h1 className="text-2xl font-bold mb-2">
          {meta.ResNo}  <br></br>
          {meta.Title}
        </h1>
        <p className="text-sm text-gray-500 mb-4">Date Enacted: {meta.DateAdopted}</p>

        <iframe
  src={pdfUrl}
  title={`Resolution ${resno}`}
  className="w-full h-full border"
  style={{ height: '100vh', width: '100%' }}
/>

      </div>
    </div>
  );
};

export default ShowResolutions;
